<template>
  <div>
    <v-stepper v-model="e1">
      <v-toolbar color="primary" dark dense flat>
        <v-toolbar-title v-if="nuevoServicio">{{$t('servicios.nuevoServicio')}}</v-toolbar-title>
        <v-toolbar-title
          v-if="(!nuevoServicio && puedoEditar)"
        >{{$t('servicios.formulario.editarServicio')}}</v-toolbar-title>
        <v-toolbar-title
          v-if="(!nuevoServicio && !puedoEditar)"
        >{{$t('servicios.formulario.visualizarServicio')}}</v-toolbar-title>
      </v-toolbar>
      <v-stepper-header class="elevation-0">
        <v-stepper-step :complete="e1 > 1" step="1">{{$t('servicios.formulario.datosServicio')}}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 2" step="2">{{$t('servicios.formulario.direccionOrigen')}}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 3" step="3">{{$t('servicios.formulario.direccionDestino')}}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4">{{$t('servicios.formulario.datosExpedicion')}}</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1" class="pt-0">
          <v-card flat>
            <b-row>
              <b-col md="2">
                <!-- Fecha -->
                <b-form-group
                  center
                  id="date"
                  :label="$t('servicios.formulario.fecha')"
                  label-for="date"
                >
                  <b-form-input
                    autocomplete="off"
                    id="date"
                    type="date"
                    v-model="servicio.Fecha"
                    @input="revisarFecha"
                    :readonly="!puedoEditar"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <!-- Hora -->
              <b-col md="2">
                <b-form-group
                  center
                  id="time"
                  :label="$t('servicios.formulario.hora')"
                  label-for="time"
                >
                  <b-form-input
                    autocomplete="off"
                    id="time"
                    type="time"
                    v-model="servicio.Hora"
                    @input="$v.servicio.$touch"
                    :readonly="!puedoEditar"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <!--Fin  Hora -->
              <b-col md="3">
                <label>{{$t('servicios.formulario.codigo')}}</label>
                <b-form-input
                  autocomplete="off"
                  id="clientName"
                  v-model="servicio.CodigoCliente"
                  @input="$v.servicio.$touch"
                  disabled
                ></b-form-input>
                <b-form-invalid-feedback
                  id="clientCode"
                  v-if="$v.servicio.$dirty"
                >{{$t('otros.esteCampoNoPuedeEstarVacio')}}</b-form-invalid-feedback>
              </b-col>
              <b-col md="5">
                <label>{{$t('servicios.formulario.cliente')}}</label>
                <b-form-input
                  autocomplete="off"
                  id="clientName"
                  v-model="servicio.NombreCliente"
                  @input="$v.servicio.$touch"
                  disabled
                ></b-form-input>
              </b-col>
            </b-row>
            <!-- Orden de servicio-->
            <b-row>
              <b-col md="4">
                <b-form-group
                  center
                  id="reference"
                  :label="$t('servicios.formulario.referencia')"
                  label-for="reference"
                >
                  <b-form-input
                    autocomplete="on"
                    id="reference"
                    name="name"
                    v-model="servicio.Referencia"
                    @input="$v.servicio.$touch"
                    :readonly="!nuevoServicio"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group class="pt-4">
                  <b-form-checkbox
                    v-model="servicio.SolicitudCliente"
                    :disabled="!puedoEditar"
                    @input="cambiarDireccionesDestino"
                  >{{$t('servicios.formulario.solicitudRecogida')}}
                  
                  <v-tooltip right>
                    <v-icon small slot="activator" dark color="primary">info</v-icon>
                    <span>{{$t('servicios.formulario.tooltipinfo')}}</span>
                  </v-tooltip>

                  </b-form-checkbox>                  
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group
                  center
                  id="servicioOrder"
                  label="Orden de servicio"
                  label-for="s"
                  v-if="!nuevoServicio"
                >
                  <b-form-input
                    autocomplete="on"
                    id="reference"
                    name="name"
                    v-model="servicio.Codigo"
                    @input="$v.servicio.$touch"
                    :readonly="true"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </v-card>

          <v-layout>
            <v-flex>
              <v-btn flat @click="dialogCancel=true">{{$t('otros.cancelar')}}</v-btn>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn color="primary" @click="avanzarDirOrigen">{{$t('otros.siguiente')}}</v-btn>
            </v-flex>
          </v-layout>
        </v-stepper-content>

        <v-stepper-content step="2" class="pt-0">
          <v-card flat>
            <b-form-checkbox
              v-model="servicio.RecogerCliente"
              @input="cambiarDireccionesOrigen"
              :disabled="!puedoEditar"
            >{{$t('servicios.formulario.recogerCliente')}}</b-form-checkbox>
            <AddressForm
              :addresses="addresses.direcciones"
              :direccion="servicio.Remitente"
              :bloqueado="!puedoEditar"
              :esDesdeServicio="true"
              :nuevoServicio="nuevoServicio"
              :esRemitente="true"
              :recogerEnCliente="servicio.RecogerCliente"
              :esDirOrigen="true"
              @estableceDireccion="estableceDireccionOrigen"
              ref="direccionOrigen"
            ></AddressForm>
          </v-card>

          <v-layout>
            <v-flex>
              <v-btn flat @click="dialogCancel=true">{{$t('otros.cancelar')}}</v-btn>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn flat @click="e1 = 1">{{$t('otros.atras')}}</v-btn>
              <v-btn
                color="primary"
                @click="e1 = 3; $refs.direccionDestino.focusNombre();"
                :disabled="(!direccionOrigenValid() && puedoEditar)"
              >{{$t('otros.siguiente')}}</v-btn>
            </v-flex>
          </v-layout>
        </v-stepper-content>

        <v-stepper-content step="3" class="pt-0">
          <v-card flat>
            <AddressForm
              :addresses="addresses.direcciones"
              :direccion="servicio.Destinatario"
              :esDesdeServicio="true"
              :esRemitente="false"
              :nuevoServicio="nuevoServicio"
              :bloqueado="!puedoEditar"
              @estableceDireccion="estableceDireccionDestino"
              ref="direccionDestino"
            ></AddressForm>
          </v-card>

          <v-layout>
            <v-flex>
              <v-btn flat @click="dialogCancel=true">{{$t('otros.cancelar')}}</v-btn>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn flat @click="e1 = 2">{{$t('otros.atras')}}</v-btn>
              <v-btn
                color="primary"
                @click="irDatosExpedicion"
                :disabled="(!direccionDestinoValid() && puedoEditar)"
              >{{$t('otros.siguiente')}}</v-btn>
            </v-flex>
          </v-layout>
        </v-stepper-content>

        <v-stepper-content step="4" class="pt-0">
          <v-card flat>
            <Expedition-Form
              :nuevoServicio="nuevoServicio"
              ref="expeditionForm"
              :puedoEditar="puedoEditar"
              :servicio="servicio"
              @checkTipoServicio="checkTipoServicio"
            ></Expedition-Form>
          </v-card>

          <v-layout>
            <v-flex>
              <v-btn flat @click="dialogCancel=true">{{$t('otros.cancelar')}}</v-btn>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn flat @click="e1 = 3">{{$t('otros.atras')}}</v-btn>
              <v-btn
                color="primary"
                @click="validateBeforeSubmit(false)"
                v-if="puedoEditar"
                :disabled="!tipoServicioSeleccionado"
              >
                <v-icon dark>save</v-icon>
                {{$t('servicios.formulario.grabarServicio')}}
              </v-btn>
              <v-btn
                color="primary"
                @click="validateBeforeSubmit(true)"
                v-if="puedoEditar"
                :disabled="!tipoServicioSeleccionado"
              >
                <v-icon dark>print</v-icon>
                {{$t('servicios.formulario.grabarServicioImprimir')}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="dialogCancel" width="400px">
      <cancelar-modal @cerrar="dialogCancel=false" />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import AddressForm from "@/components/addresses/AddressFormV2";
import ExpeditionForm from "@/components/expeditions/ExpeditionForm";
import CancelarModal from "../CancelarModal";
import { EventBus } from "./../../event-bus.js";

export default {
  mounted() {
    this.fetchAddresses(this.filtro);
    this.servicio.NombreCliente = this.Auth.Usuario.DOMICILIO.Nombre;
    this.servicio.CodigoCliente = this.Auth.Usuario.DOMICILIO.CodigoCliente;
    this.servicio.Fecha = this.servicio.Fecha.split("T")[0];
    this.servicio.FechaPrevista = this.servicio.FechaPrevista.split("T")[0];
    this.revisarFecha();

    if (this.nuevoServicio && this.puedoEditar) {
      this.servicio.RecogerCliente = true;
      this.cambiarDireccionesOrigen();
    }
  },
  components: { AddressForm, ExpeditionForm, CancelarModal },
  data() {
    return {
      e1: 0,
      dialogCancel: false,
      showTooltipInfo: false,
      tipoServicioSeleccionado: false,
      tabServicioValido: true,
      tabExpedicciones: false,
      direcciones: this.$store.state.addresses,
      esRemitente: false,
      servicio: JSON.parse(JSON.stringify(this.servicioOriginal)), //Clonado del ServicioOriginal
      remitenteOrigen: JSON.parse(
        JSON.stringify(this.servicioOriginal.Remitente)
      ),
      destinatarioOrigen: JSON.parse(
        JSON.stringify(this.servicioOriginal.Destinatario)
      )
    };
  },
  props: {
    servicioOriginal: {
      type: Object,
      required: true
    },
    nuevoServicio: {
      type: Boolean,
      required: false,
      default: false
    },
    puedoEditar: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  validations: {
    servicio: {}
  },
  methods: {
    checkTipoServicio() {
      if (this.servicio.TipoServicio.code !== undefined)
        this.tipoServicioSeleccionado = true;
    },
    revisarFecha() {
      this.$refs.expeditionForm.revisarFecha();
    },
    avanzarDirOrigen() {
      this.e1 = 2;
      this.$refs.direccionOrigen.filtrarAPI();
      this.$refs.direccionOrigen.focusNombre();
    },
    direccionOrigenValid() {
      if (!this.$refs.direccionOrigen) return false;
      return this.$refs.direccionOrigen.valid;
    },
    direccionDestinoValid() {
      if (!this.$refs.direccionDestino) return false;
      return this.$refs.direccionDestino.valid;
    },
    irDatosExpedicion() {
      this.e1 = 4;
      if (this.nuevoServicio) EventBus.$emit("cargarTiposServicio");
    },
    validateBeforeSubmit(imprimir) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      if (new Date(this.servicio.Fecha) < today) {
        this.$toast(
          "No se puede crear un servicio con una fecha anterior a la de hoy",
          { color: "red" }
        );
        //return;
      }
      //console.log("Fecha " + this.servicio.Fecha);
      //console.log("today " + today);
      //console.log(new Date(this.servicio.Fecha) < today);
      let data = {
        servicio: this.servicio,
        imprimir: imprimir
      };
      this.$emit("servicioSubmit", data);
    },
    ...mapActions("addresses", ["fetchAddresses"]),
    selectedAddress(index) {
      if (index === 1) {
        this.esRemitente = true;
      }
      if (index === 1) {
        this.esRemitente = false;
      }
    },
    cambiarDireccionesOrigen() {
      //Cambia las direcciones origen cuando se marca el check de "Recoger en Cliente"
      if (this.servicio.RecogerCliente) {
        this.servicio.Remitente = JSON.parse(
          JSON.stringify(this.Auth.Usuario.DOMICILIO)
        );
        this.servicio.Remitente.Codigo = "DirCli";

        this.servicio.SolicitudCliente = false;
        let dirOrigen = this.$refs.direccionOrigen;
        setTimeout(function() {
          dirOrigen.loading = false;
          dirOrigen.filtrarAPI();
        }, 50);
      } else {
        this.servicio.SolicitudCliente = true;
        this.$refs.direccionOrigen.clear();
      }
    },
    cambiarDireccionesDestino() {
      if (this.servicio.SolicitudCliente) {
        this.servicio.Destinatario = JSON.parse(
          JSON.stringify(this.Auth.Usuario.DOMICILIO)
        );
        this.servicio.Destinatario.Codigo = "DirCli";

        let dirDestino = this.$refs.direccionDestino;

        this.servicio.RecogerCliente = false;
        this.$refs.direccionOrigen.clear();

        setTimeout(function() {
          dirDestino.loading = false;
          dirDestino.filtrarAPI();
        }, 1000);
      } else {
        this.servicio.RecogerCliente = true;
        this.$refs.direccionDestino.clear();
      }
    },
    estableceDireccionOrigen(direccion) {
      if (this.servicio.RecogerCliente) return;
      //console.log("ORIGEN "+JSON.stringify(direccion));
      this.servicio.Remitente = direccion;
    },
    estableceDireccionDestino(direccion) {
      //console.log("DESTINO "+JSON.stringify(direccion));
      this.servicio.Destinatario = direccion;
    }
  },
  computed: {
    ...mapGetters("addresses", ["addresses", "defecto"]),
    ...mapState(["Auth"])
  }
};
</script>

<style>
</style>
